export const STORAGE = {
  ROLE: "roleId",
};
